import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

// Типы сообщений
type WebSocketMessage = {};
// | { type: 'DEVICE_STATUS'; payload: { deviceId: string; online: boolean } }
// | { type: 'AUDIO_RECORDING_STARTED'; payload: { deviceId: string; timestamp: number } }
// | { type: 'ALERT_TRIGGERED'; payload: { alertId: string; deviceId: string } };

interface WebSocketState {
    socket: WebSocket | null;
    isConnected: boolean;
    connect: (url: string) => void;
    disconnect: () => void;
    sendMessage: (message: object) => void;
    handleMessage: (message: WebSocketMessage) => void;
}

export const useWebSocketStore = create(
    immer<WebSocketState>((set, get) => ({
        socket: null,
        isConnected: false,

        connect: (url: string) => {
            const socket = new WebSocket(url);
            socket.binaryType = 'arraybuffer';

            socket.onopen = () => {
                set({ isConnected: true });
                console.log('WebSocket connected');
            };

            socket.onmessage = (event: MessageEvent<ArrayBuffer>) => {
                try {
                    // const decoder = new TextDecoder('utf-8');
                    // const text = decoder.decode(new Uint8Array(event.data));
                    // const data = JSON.parse(text) as WebSocketMessage;
                    // get().handleMessage(data); // Обработка сообщения
                } catch (error) {
                    console.error('Error parsing WebSocket message:', error);
                }
            };

            socket.onerror = (error) => {
                console.error('WebSocket error:', error);
                set({ isConnected: false });
            };

            socket.onclose = () => {
                console.log('WebSocket disconnected');
                set({ isConnected: false, socket: null });
                // Автопереподключение (опционально)
                setTimeout(() => get().connect(url), 3000);
            };

            set({ socket });
        },

        disconnect: () => {
            get().socket?.close();
            set({ socket: null, isConnected: false });
        },

        sendMessage: (message: object) => {
            const { socket, isConnected } = get();
            if (isConnected && socket) {
                socket.send(JSON.stringify(message));
            } else {
                console.warn('WebSocket is not connected');
            }
        },

        handleMessage: (message) => {
            // Здесь можно вызывать другие stores или напрямую обновлять состояние
            // switch (message.type) {
            //     case 'DEVICE_STATUS':
            //         // Пример: обновляем статус устройства в другом store
            //         useDeviceStore
            //             .getState()
            //             .updateDeviceStatus(message.payload.deviceId, message.payload.online);
            //         break;
            //     case 'AUDIO_RECORDING_STARTED':
            //         // Логика для аудио
            //         break;
            //     default:
            //         console.log('Unhandled message type:', message.type);
            // }
        },
    })),
);
